import React from 'react';

interface Props {}

const VerticalFeather: React.FC<Props> = () => (
  <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-b from-transparent to-white" />
);

export default VerticalFeather;
